export default __webpack_public_path__ + "static/pillar-1-e2c87be035f93c2e1786dd728fc06981.jpg";